<template>
    <v-app class="main">
        <vue-cookie-accept-decline
            tabindex="0"
            style="max-width: 512px"
            :ref="'myPanel1'"
            :elementId="'myPanel1'"
            :debug="false"
            :position="'bottom-left'"
            :type="'floating'"
            :disableDecline="false"
            :transitionName="'slideFromBottom'"
            :showPostponeButton="false"
            @clicked-accept="cookieClickedAccept"
            @clicked-decline="cookieClickedDecline">

            <div slot="postponeContent">
                &times;
            </div>

            <div slot="message">
                Wir nutzen Cookies auf dieser Website. Einige Cookies sind zum ordnungsgemäßen Funktionieren dieser Website und für Komfortfunktionalitäten erforderlich (Notwendige Cookies).
                Mit Ihrer Zustimmung benutzt der Mietspiegel das Web-Analysetool Matomo zur Erhebung von Daten zu Ihrem Nutzungsverhalten auf dieser Seite. Dabei werden zusätzliche Cookies gesetzt. Ihre Zustimmung ist freiwillig und jederzeit widerrufbar.
                Weitere Informationen finden Sie in unserer <a href="/datenschutz.html" target="_blank" rel="noopener noreferrer" data-ajax="false">Datenschutzerklärung</a>. Dort können Sie unten auf der Seite jederzeit Ihre Zustimmung widerrufen.
                Bitte treffen Sie eine Auswahl, um fortzufahren.

            </div>

            <div slot="declineContent">
                Nur Notwendige Cookies
            </div>

            <div slot="acceptContent">
                Alle akzeptieren (inklusive Matomo)
            </div>
        </vue-cookie-accept-decline>
        <TheSnackbar/>
        <div class="d-md-none">
            <nav aria-label="Berechnungsschritte">
            <v-navigation-drawer
                  v-model="overlayDrawer"
                  absolute
                  temporary
                  @input="setExpansionState()"
            >
                <perfect-scrollbar class="psmobile">
                    <v-list nav ref="mobileDrawerList">
                        <v-list-item v-for="(item, index) in items" :key="item.path" :to="item.path" :disabled="_isDisabled(index)">
                            <v-list-item-content>
                                <v-list-item-title :class="_getTextColor(item.error)">
                                    <v-badge v-if="item.error"
                                        color="#c50517"
                                        left
                                        offset-x="62"
                                        offset-y="-1"
                                        content="Konflikt!"
                                        style="margin-top:22px">
                                        <v-icon style="color:#c50517">mdi-alert</v-icon>
                                    </v-badge>
                                    <v-icon v-else :class="_getColor(item.icon)">{{_getIcon(item.icon)}}</v-icon>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </perfect-scrollbar>
            </v-navigation-drawer>
            </nav>
        </div>
        <div v-html="htmlHeader">
        </div>
        <div data-role="header" class="mainHeader">
                {{$t('mietspiegel.title')}} {{ version }}
        </div>
        <v-container class="pb-0">
            <v-row no-gutter>
                <v-col class="d-none d-md-flex flex-grow-0">
                    <nav aria-label="Berechnungsschritte">
                    <v-navigation-drawer permanent style="max-height:640px" v-model="drawer">
                    <perfect-scrollbar class="psnormal">
                        <v-list nav ref="permanentDrawerList">
                            <v-list-item v-for="(item, index) in items" :key="item.path" :to="item.path" :disabled="_isDisabled(index)">
                                <v-list-item-content>
                                    <v-list-item-title :class="_getTextColor(item.error)">
                                        <v-badge v-if="item.error"
                                            color="#c50517"
                                            left
                                            offset-x="62"
                                            offset-y="-1"
                                            content="Konflikt!"
                                            style="margin-top:22px">
                                            <v-icon style="color:#c50517">mdi-alert</v-icon>
                                        </v-badge>
                                        <v-icon v-else :class="_getColor(item.icon)">{{_getIcon(item.icon)}}</v-icon>
                                        {{ item.title }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </perfect-scrollbar>
                    </v-navigation-drawer>
                    </nav>
                </v-col>
                <v-col class="d-flex flex-grow-1" style="max-width:640px; margin-left: auto; margin-right: auto;">
                    <v-content>
                        <v-btn class="d-md-none" ref="navigationButton" aria-label="Navigationsmenü öffnen" :aria-expanded="berechnungsschritteShown" aria-haspopup="true" style="margin-left: 24px; min-width: 44px; width: 44px;" @click.stop="_openNavigationDrawer()">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                        <v-container >
                            <v-fade-transition mode="out-in">
                                <router-view></router-view>
                            </v-fade-transition>
                        </v-container>
                    </v-content>
                </v-col>
            </v-row>
        </v-container>
        <div v-html="htmlFooter">
        </div>
    </v-app>
</template>

<style>
    @import './mietspiegel.css';
</style>

<script lang="ts">
    import Vue from 'vue'
    import { Route } from 'vue-router'
    import Component from 'vue-class-component'
    import {Watch} from 'vue-property-decorator';
    import TheSnackbar from '@/components/TheSnackbar.vue'
    import { mdiSettings } from '@mdi/js'
    import { mapState } from 'vuex';
    import { EventBus } from './eventbus';
    import { BerechnungState } from './store/modules/berechnung';
    import { ErgebnisState } from './store/modules/ergebnis';
    import EnvironmentInfoService from "@/api/EnvironmentInfoService";

    @Component({
        components: {TheSnackbar},
        computed: { ...mapState('error', ['baujahr']),
                    ...mapState('error', ['gebaeudetyp']),
                    ...mapState('error', ['haustyp']),
                    ...mapState('error', ['sanitaerbereich']),
                    ...mapState('error', ['kuechengrundausstattung']),
                    ...mapState('error', ['elektrogeraete']),
                    ...mapState('error', ['fussboden']),
                    ...mapState('error', ['modernisierterBoden']),
                    ...mapState('error', ['terrasseBalkon']),
                    ...mapState('error', ['modernisierteFenster']),
                    ...mapState('error', ['abweichungen'])
        },
    })
    export default class App extends Vue {

        // necessary because of missing typescript compatibility of vuex mappers
        loadUserinfo() {
            this.$store.dispatch('user/loadUserinfo')
        }
        RESET_BERECHNUNG() {
            this.$store.dispatch('berechnung/RESET_BERECHNUNG')
        }
        RESET_ERRORS() {
            this.$store.dispatch('error/RESET_ERRORS')
        }
        RESET_ERGEBNIS() {
            this.$store.dispatch('ergebnis/RESET_ERGEBNIS')
        }
        RESET_SEARCH() {
            this.$store.dispatch('search/RESET_SEARCH')
        }
        setResult(ergebnis: ErgebnisState) {
            this.$store.dispatch('ergebnis/SET_ERGEBNIS', { ergebnis: ergebnis })
        }

        // type script declarations for mapped store attributes
        private baujahr!: boolean
        private gebaeudetyp!: boolean
        private haustyp!: boolean
        private sanitaerbereich!: boolean
        private kuechengrundausstattung!: boolean
        private elektrogeraete!: boolean
        private fussboden!: boolean
        private modernisierterBoden!: boolean
        private terrasseBalkon!: boolean
        private modernisierteFenster!: boolean
        private abweichungen!: boolean
        version: String = ''

        @Watch('$route')
        onRouteChanged(to:Route){
            document.title = 'Mietspiegel München Online - ' + to?.meta?.title || 'Online-Rechner'
        }

        //Watch all possible errors
        @Watch('baujahr')
        onBaujahrErrorChanged(){
            //update array value / not reactive
            //access via $data because of typescript error
            this.$data.items[3].error = this.baujahr
        }

        @Watch('gebaeudetyp')
        onGebaeudetypErrorChanged(){
            this.$data.items[5].error = this.gebaeudetyp
        }

        @Watch('haustyp')
        onHaustypErrorChanged(){
            this.$data.items[6].error = this.haustyp
        }

        @Watch('sanitaerbereich')
        onSanitaerbereichErrorChanged(){
            this.$data.items[9].error = this.sanitaerbereich
        }

        @Watch('kuechengrundausstattung')
        onKuechengrundausstattungErrorChanged(){
            this.$data.items[11].error = this.kuechengrundausstattung
        }

        @Watch('elektrogeraete')
        onElektrogeraeteErrorChanged(){
            this.$data.items[12].error = this.elektrogeraete
        }

        @Watch('fussboden')
        onFussbodenErrorChanged(){
            this.$data.items[13].error = this.fussboden
        }

        @Watch('modernisierterBoden')
        onModernisierterBodenErrorChanged(){
            this.$data.items[14].error = this.modernisierterBoden
        }

        @Watch('terrasseBalkon')
        onTerrasseBalkonErrorChanged(){
            this.$data.items[15].error = this.terrasseBalkon
        }

        @Watch('abweichungen')
        onAbweichungenErrorChanged(){
            this.$data.items[18].error = this.abweichungen
        }

        @Watch('modernisierteFenster')
        onModernisierteFensterErrorChanged(){
            this.$data.items[17].error = this.modernisierteFenster
        }

        setExpansionState(){
            this.$data.berechnungsschritteShown = !this.$data.berechnungsschritteShown
        }

        get berechnung(): BerechnungState {
            return this.$store.state.berechnung
        }

        drawer: boolean = true
        query:string = ''

        data() {
            return {
                backendUrl: this.getBackendUrl(),
                berechnungsschritteShown: false,
                items: [
                    { title: 'Neue Berechnung', icon: mdiSettings, path: '/berechnung'},
                    { title: 'Zu-/Abschläge', icon: 'mdi-information-outline', path: '/zuschlaege'},
                    { title: 'Wohnfläche', icon: 'wohnflaeche', path: '/wohnflaeche'},
                    { title: 'Baujahr', icon: 'selectedBaujahr', path: '/baujahr', error: this.baujahr},
                    { title: 'Wohnlage', icon: 'selectedWohnlage', path: '/wohnlage'},
                    { title: 'Gebäudetypen', icon: 'selectedGebaeudetyp', path: '/gebaeudetyp', error: this.gebaeudetyp},
                    { title: 'Haustypen', icon: 'selectedHaustyp', path: '/haustyp', error: this.haustyp},
                    { title: 'Unvollständige Beheizung', icon: 'selectedUnvollstaendigBeheizung', path: '/heizung'},
                    { title: 'Fußbodenheizung', icon: 'selectedFussbodenheizung', path: '/fussbodenheizung'},
                    { title: 'Sanitärbereich', icon: 'selectedSanitaerbereich', path: '/sanitaerbereich', error: this.sanitaerbereich},
                    { title: 'Offene Küche', icon: 'selectedKueche', path: '/kueche'},
                    { title: 'Küchengrundausstattung', icon: 'selectedKuechengrundausstattung', path: '/kuechengrundausstattung'},
                    { title: 'Elektrogeräte (Küche)', icon: 'selectedElektrogeraete', path: '/elektrogeraete'},
                    { title: 'Fußboden', icon: 'selectedFussboden', path: '/fussboden', error: this.fussboden},
                    { title: 'Modernisierter Boden', icon: 'selectedModernisierterBoden', path: '/modernisierterBoden', error: this.modernisierterBoden},
                    { title: 'Terrasse/Dachterrasse/Balkon/Loggia', icon: 'selectedTerrasseBalkon', path: '/terrasseBalkon', error: this.terrasseBalkon},
                    { title: 'Besondere Ausstattung', icon: 'selectedBesondereAusstattung', path: '/ausstattung'},
                    { title: 'Modernisierte Fenster', icon: 'selectedModernisierteFenster', path: '/modernisierteFenster'},
                    { title: 'Begründete Abweichungen', icon: 'abweichungGesetzt', path: '/abweichungen', error: this.abweichungen},
                    { title: 'Betriebskosten', icon: 'selectedBetriebskostenA', path: '/betriebskosten'},
                    { title: 'Berechnungsergebnisse', icon: 'selectedBetriebskostenA', path: '/berechnungsergebnisse'}
                ],
                htmlHeader: `
                <div data-role="page" id="index" style="width: 100% !important; margin: 0 auto !important; position: relative !important;">
                    <header>
                        <div class="muenchenDe" role="banner" style="height:70px; min-width:360px; border: 0; margin: 0; padding: 0;">
                            <div style="float:left; height:70px;">
                                <a href="http://www.muenchen.de" tabindex="30" target="_blank" data-ajax="false">
                                    <img src='/logo-muenchen.png'
                                         style="border: 0; height: 70px; overflow: hidden;"
                                         alt="muenchen.de - Das offizielle Stadtportal"
                                         title="muenchen.de - Das offizielle Stadtportal">
                                </a>
                            </div>

                            <div class="right mobilehidden" style="height: 70px;">
                                <a href="https://www.muenchen.de/rathaus/Stadtverwaltung/Sozialreferat/Wohnungsamt/Mietspiegel.html" tabindex="31" target="_blank">
                                    <img src="/soz_logo_190x52_transp.png"
                                         width="190" height="52" style="margin-top: 18px; border: 0;"
                                         alt="Landeshauptstadt M&uuml;nchen, Sozialreferat"
                                         title="Landeshauptstadt M&uuml;nchen, Sozialreferat">
                                </a>
                            </div>
                        </div>
                        <nav>
                            <div class="horizontalMenu" role="navigation">
                                <ul class="menuHorizontal">
                                    <li class="">
                                        <a href="http://www.muenchen.de/rathaus/home.html" data-ajax="false">
                                            Rathaus
                                        </a>
                                    </li>

                                    <li class="">
                                        <a href="/" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                            Vorwort
                                        </a>
                                    </li>

                                    <li class="btn-menu-selected">
                                        <a href="/berechnung.html#/" data-ajax="false">
                                            Online-Rechner
                                        </a>
                                    </li>

                                    <li class="">
                                        <a href="/grundlagen.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                            Grundlagen
                                        </a>
                                    </li>

                                    <li class="">
                                        <a href="/dokumentation.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                            Dokumentation
                                        </a>
                                    </li>

                                    <li class="">
                                        <a href="/gesetzeslage.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                            Gesetzeslage
                                        </a>
                                    </li>

                                    <li class="">
                                        <a href="/service.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                            Service
                                        </a>
                                    </li>
                                </ul>

                            </div>
                            <div class="horizontalMenuButton" >
                                <a href="#menuMietspiegelPanel" class="ui-btn ui-btn-inline ui-icon-bars ui-btn-icon-left ui-corner-all ui-mini"
                                   title="Hauptmen&uuml; anzeigen">Hauptmen&uuml;</a>
                            </div>
                        </nav>
                    </header>
                </div>
                `,
                htmlFooter: `
                <footer>
                <div data-role="footer" role="banner">
                	<div class="footer"
                		style="height: 136px; background-image: url(/skyline_ver2.png); background-position: left bottom; background-repeat: repeat-x;">
                		&nbsp;
                		<ul class="menuHorizontalFooter">
                		    <li class="">
                                <a href="/impressum.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                    Impressum
                                </a>
                            </li>
                            <li class="">
                                <a href="/datenschutz.html" target="_blank" rel="noopener noreferrer" data-ajax="false">
                                    Datenschutz
                                </a>
                            </li>
                         </ul>
                	</div>
                </div>
                </footer>
                `,
                overlayDrawer: null,
                currentIndex: 0,
                goToFocus: false
            }
        }

        _focusDrawer() {
            if(this.$data.overlayDrawer) {
                setTimeout(function() {
                    this.$refs.mobileDrawerList.$children[0].$el.focus();
                }, 300);
            }
        }

        _openNavigationDrawer() {
            window.scrollTo(0, 0);
            this.$data.overlayDrawer = !this.$data.overlayDrawer;
            if(this.$data.overlayDrawer) {
                this.$data.goToFocus = true;
                this._scrollToPosition('.psmobile', this.$data.currentIndex);
            }
        }

        _closeMobileDrawer() {
            this.$data.overlayDrawer = false;
            ((this.$refs.navigationButton as Vue).$el as HTMLElement).focus()
        }

        getBackendUrl() {
            if (window.location.hostname === 'localhost' && window.location.port === '8081') {
                return 'http://localhost:8082';
            } else {
                return '';
            }
        }

        _getIcon(prop: string) {
            if (this.$store.state.berechnung[prop] === undefined) {
                if(!(prop.startsWith('mdi') || /M\d/.test(prop))){
                    return 'mdi-pencil';
                }else{
                    return prop;
                }
            }
            if (this.$store.state.berechnung[prop] === '' || this.$store.state.berechnung[prop] === null || this.$store.state.berechnung[prop] === false || this.$store.state.berechnung[prop].length == 0) {
                return 'mdi-pencil';
            }
            return 'mdi-check-circle-outline';
        }

        _getColor(prop: string) {
            if (prop.startsWith('mdi') || /M\d/.test(prop)) {
                if (prop === 'mdi-information-outline') {
                    return 'icon-blue';
                } else {
                    return 'icon-grey';
                }
            }
            if (this.$store.state.berechnung[prop] === '' || this.$store.state.berechnung[prop] === null || this.$store.state.berechnung[prop] === false || this.$store.state.berechnung[prop].length == 0) {
                return 'icon-grey';
            }
            return 'icon-green';
        }

        _getTextColor(error: boolean) {
            if(error){
                return "red--text font-weight-bold";
            }
        }

        _isDisabled(index: number) {
            if (index < 3) {
                // Menüpunkte bis Wohnfläche sind immer aktiviert
                return false;
            }
            var prevProp = this.$data.items[index-1].icon;
            var error = this.$data.items[index-1].error;
            var prop = this.$data.items[index].icon;
            /*
             * drawer element is disabled as long as the previous element has no value in the store
             * or itself has no value and the previous one an error
             */
            if ((this.$store.state.berechnung[prevProp] === undefined || this.$store.state.berechnung[prevProp] === '' || this.$store.state.berechnung[prevProp] === null || this.$store.state.berechnung[prevProp] === false || this.$store.state.berechnung[prevProp].length == 0)
            || (error && (this.$store.state.berechnung[prop] === undefined || this.$store.state.berechnung[prop] === '' || this.$store.state.berechnung[prop] === null || this.$store.state.berechnung[prop] === false || this.$store.state.berechnung[prop].length == 0))) {
                return true;
            }
            return false;
        }

        mounted() {
            this.query = this.$route.params.query;
            document.title = 'Mietspiegel München Online - ' + this.$route?.meta?.title
            EventBus.$on('reset', this._resetData);
            EventBus.$on('scroll', this._scrollMenuToPosition);
            EventBus.$on('berechnung', this._callBerechnung);
            var vm = this;
            window.addEventListener('keydown', e => {
                if(e.key === "Escape") {
                    vm._closeMobileDrawer();
                } else if (e.keyCode === 9) {
                    if (vm.$data.overlayDrawer) {
                        if(vm.$data.goToFocus) {
                            vm.$data.goToFocus = false;
                            setTimeout(function() {
                                const list: any = vm.$refs.mobileDrawerList;
                                list.$children[0].$el.focus();
                            }, 50);
                        } else {
                            setTimeout(function() {
                                if(document.activeElement && !document.activeElement.className.includes("v-list-item")) {
                                    vm._closeMobileDrawer();
                                }
                            }, 50);
                        }
                    }
                }
                if(e.key === 'Tab' && e.shiftKey){
                    const target: any = e.target
                    if (target.parentElement.classList.contains('v-list-item-group') && target.className.includes('v-list-item')){
                        if(vm.$vuetify.breakpoint.mdAndUp){
                            (Array.from((vm.$refs.permanentDrawerList as Vue).$el.children).filter(child => child.classList.contains('v-list-item--active'))[0] as HTMLElement).focus()
                        }else{
                            ((vm.$refs.navigationButton as Vue).$el as HTMLElement).focus()
                        }
                        e.preventDefault()
                        //for special handling in components with additional inputs above item list
                        vm.$root.$emit('unfocusList', target)
                    }
                }
                //shift focus on items in the views via arrow keys
                if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return
                    const target : any = e.target
                    /*
                     * if v-list is disabled, see e.g. Betriebskosten, no navigation allowed in order to prevent
                     * (de)selection of disabled elements using 'Enter', ... (not automatically supported by component)
                     */
                    if(target.parentElement.className.includes('disabled') || (target.parentElement.parentElement && target.parentElement.parentElement.className.includes('disabled'))) return
                    if(target.className.includes('v-list-item-group')){
                        target.firstChild.focus()
                        e.preventDefault()
                    }else if (target.parentElement.classList.contains('v-list-item-group') && target.className.includes('v-list-item')){
                        if(e.key === 'ArrowDown' && target.nextSibling){
                            target.nextSibling.nextSibling.focus()
                        }else if(e.key === 'ArrowUp' && target.previousSibling){
                            target.previousSibling.previousSibling.focus()
                        }
                        e.preventDefault()
                    }
            });

            // Load Version
            EnvironmentInfoService.getEnvironmentInfo()
                .then(value => {
                  this.version = value.vueAppVersion;
                })
                .catch(reason => {
                    console.log(reason)
                  this.version = "";
                })
        }

        _resetData() {
            this.RESET_ERRORS()
            this.RESET_BERECHNUNG()
            this.RESET_ERGEBNIS()
            this.RESET_SEARCH()
        }

        _callBerechnung(result: any) {
            if (result != null) {
                this.setResult(result);
            }
        }

        _scrollMenuToPosition(index: number) {
            if(!(window.location.hash.includes("info=wohnlage") || window.location.hash.includes("info=gebaeudetypen"))){
                this._scrollToPosition('.psnormal', index);
            }
        }

        _scrollToPosition(scrollbar: string, index: number) {
            this.$data.currentIndex = index;
            const container = this.$el.querySelector(scrollbar);
            var length = this.$data.items.length;
            // Offset in the menu
            var offset = 3;
            if (container != null && index != null && length != null) {
                container.scrollTop = (index - offset) * container.scrollHeight / length;
            }
        }

        @Watch('$route.params.query')
        function (query: string) {
            if (this.query !== query)
                this.query = query;
        }

        //Navigiert zur Seite mit den Suchergebnissen und sendet ein Event zum Auslösen weiterer Suchen.
        async search() {
            if (this.query !== '' && this.query !== null) {
                this.$store.dispatch('snackbar/showMessage', {message: "Sie haben nach " + this.query + " gesucht. ;)"});
            }
        }

        cookieClickedAccept() {
            const win: any = window;
            var _paq = win._paq || [];
            _paq.push(['rememberConsentGiven'])
        }

        cookieClickedDecline() {
            const win: any = window;
            var _paq = win._paq || [];
            _paq.push(['forgetConsentGiven']);
        }
    }
</script>
